import {
  Referential,
  ReferentialItem,
} from '@teetsh/app/src/containers/CarnetsDeNotes/types/carnetsDeNotes';

export function findItemFromBOById(
  id: string,
  referential: Referential,
): ReferentialItem | undefined {
  const matchingMatiere = (referential.matieres || []).find(m => m.id === id);
  if (matchingMatiere) {
    return matchingMatiere;
  }
  const matchingDomaine = (referential.domaines || []).find(m => m.id === id);
  if (matchingDomaine) {
    return matchingDomaine;
  }
  const matchingCompetence = (referential.competences || []).find(
    m => m.id === id,
  );
  if (matchingCompetence) {
    return matchingCompetence;
  }
  const matchingObjectif = (referential.objectifs || []).find(m => m.id === id);
  if (matchingObjectif) {
    return matchingObjectif;
  }
  return undefined;
}
